import React, {
  useEffect,
} from "react";
import { Outlet } from "react-router-dom";
import { useMainStore } from "./store";

function App() {
  const auth = useMainStore((s) => s.auth);
  const updateAuth = useMainStore((s) => s.updateAuth);
  const updateWallet = useMainStore((s) => s.updateWallet);

  useEffect(() => {
    if (typeof window.ethereum !== "undefined") {
      window.ethereum.on("accountsChanged", function (accounts: any) {
        updateWallet(accounts[0]);
      });
    }
  }, []);

  useEffect(() => {
    if (!auth) {
      const fn = async () => {
        const { id, sig } = await fetch(
          `${process.env.REACT_APP_REQUEST_URL}/auth`,
          {
            method: "post",
          }
        ).then((res) => res.json());
        updateAuth(`${id}:${sig}`);
      };
      fn();
    }
  }, []);

  return <Outlet />;
}

export default App;
